'use client'

import { useRouter } from 'next/navigation'

import productButtonsCl from '@/widgets/ProductButtons/ProductButtons.module.scss'

import { useOpenAccessoriesOffer } from '@/features/cart/accessories-offer'

import { getDiscountOrderUrl, isDiscountBuyAvailable } from '@/entities/catalog-discount'

import { DISCOUNT_ORDER_SOURCE } from '@/shared/lib/const/order-source'
import { OrderType, TProduct } from '@/shared/types/product-types'
import { Button } from '@/shared/ui'

import cl from '../../ui/product-main/product-panel/components/buy-buttons-panel/buy-buttons-panel.module.scss'

type DiscountBuyButtonProps = {
	product: TProduct
	fullWidth?: boolean
	size?: 'S' | 'M' | 'L'
	className?: string
	inFixedPanel?: boolean
}

export const DiscountBuyButton = ({
	product,
	fullWidth = true,
	size = 'L',
	className,
	inFixedPanel = false
}: DiscountBuyButtonProps): JSX.Element | null => {
	const router = useRouter()
	const { loadingAction, openOrderWithAccessories } = useOpenAccessoriesOffer()

	if (product.ORDER_TYPE === OrderType.Archive) return null

	if (!isDiscountBuyAvailable(product)) return null

	const orderUrl = getDiscountOrderUrl({ ID: product.ID })
	const onClick = () => {
		if (product.ORDER_TYPE !== OrderType.PreOrder) return router.push(orderUrl)

		return openOrderWithAccessories({
			action: 'preorder',
			orderQuery: { source: DISCOUNT_ORDER_SOURCE },
			productCode: product.KOD,
			productId: product.ID,
			productPreview: { TITLE: product.TITLE, IMAGE: product.IMAGE || product.IMAGES?.[0] }
		})
	}

	const button = (
		<div className={productButtonsCl.productButtons}>
			<Button
				size={size}
				fullWidth={fullWidth}
				className={`gtm-fast-order ${className ?? ''}`.trim()}
				onClick={onClick}
				isLoading={loadingAction === 'preorder'}
				disabled={loadingAction === 'preorder'}>
				Купить
			</Button>
		</div>
	)

	if (inFixedPanel) {
		return button
	}

	return <section className={fullWidth ? cl.buyButtonsPanel : undefined}>{button}</section>
}
